import { defineComponent as _defineComponent } from 'vue'
import { watch, useContext, computed } from '@nuxtjs/composition-api';

// TODO: find a way how we could make BravadoTheme with forced theme inside the page, because now it's not possible
type BravadoThemeProps = {
  forcedTheme?: 'dark' | 'light' | 'auto' | '';
};


export default /*#__PURE__*/_defineComponent({
  __name: 'BravadoTheme',
  props: {
    forcedTheme: { default: '' }
  },
  setup(__props: any) {

const props = __props as { forcedTheme: 'dark' | 'light' | 'auto' | '' };



const { $auth, $colorMode } = useContext();

const getThemeName = (theme: 'dark' | 'light' | 'auto') => (theme === 'auto' ? 'system' : theme);

const theme = computed(() => props.forcedTheme || $colorMode.value);
const rootClass = computed(() => {
  if (props.forcedTheme) return `bravado-theme--${theme.value}`;
});

/**
 * Change the theme on initial load
 */
watch(
  () => $auth.user,
  newUser => {
    if (!process.client) return;

    if ($auth.loggedIn && $colorMode) {
      window.requestAnimationFrame(() => {
        $colorMode.preference = getThemeName(newUser?.uiTheme || 'auto');
      });
    }
  },
  { immediate: true },
);
// Styles for this component included globally to have css variables in the first styles file

return { __sfc: true,props, $auth, $colorMode, getThemeName, theme, rootClass }
}

})